import { useEffect, useState } from "react";
import { createUseStyles } from "react-jss";
import { useEvent } from "js-events-listener/react";

import { fetchMedia } from "./Content";
import { getTheme } from "../Customisation";

const useStyles = createUseStyles(theme => ({
  content: {
    background: theme.popupSecondary,
    color: theme.textSecondary,
    textAlign: "left",
    "box-sizing": "border-box",
    padding: [5, 20],
    marginTop: getTheme().popupSpace ?? 1,
    width: "100%",

    "& p": {
      lineHeight: "1.4em",
      margin: [10, 0],
      fontSize: "14px",

      "& a": {
        color: theme.textHighlight,
      },
    },
  },
  aspectRatio: {
    width: "100%",
    paddingTop: "min(56.25%, 100vh - 43px)",
    height: props => (props.large ? "calc(100vh - 43px)" : undefined),
    marginTop: getTheme().popupSpace ?? 1,
    position: "relative",
    "& iframe": {
      backgroundColor: theme.popupSecondary,
      position: "absolute",
      top: 0,
      left: 0,
      width: "100%",
      height: "100%",
    },
  },
  video: {
    width: `calc(100% + ${40 + getTheme().popupSpace ?? 1}px)`,
    marginTop: getTheme().popupSpace ?? 1,
  },
  error: {
    extend: "content",
    textAlign: "center",
  },
}));

const Video = ({ video_type, url: urlProp, video = {}, large, session }) => {
  const [url, setUrl] = useState(urlProp);
  const [mimeType, setMimeType] = useState();
  const [err, setErr] = useState(false);
  const [hasControl, setHasControl] = useState(!window.eventTours.lockControl);
  const classes = useStyles({ large });

  useEvent("LOCK_CONTROL", () => setHasControl(false), []);
  useEvent("UNLOCK_CONTROL", () => setHasControl(true), []);

  useEffect(() => {
    if (video_type === "cms") {
      fetchMedia(video.id)
        .then(data => {
          setUrl(data.public_url);
          setMimeType(data.mime_type);
        })
        .catch(e => {
          console.error(e);
          setErr(true);
        });
    }
  }, [video_type, video.id]);

  if (err) return <div className={classes.error}>Failed to load video</div>;

  switch (video_type) {
    case "youtube":
      try {
        let yurl = "";
        // check for shortened youtube links
        if (url.indexOf("youtu.be") > 0) {
          yurl = url.replace("youtu.be", "youtube.com/embed").split("?")[0];
        } else {
          yurl = `https://www.youtube.com/embed/${
            url.split("v=")[1].split("&")[0]
          }`;
        }
        return (
          <div className={classes.aspectRatio}>
            <iframe
              title="Youtube Embed"
              src={encodeURI(yurl)}
              width="100%"
              height="100%"
              allowFullScreen
              frameBorder="0"
            />
          </div>
        );
      } catch (err) {
        console.error("Youtube link error", err);
        return (
          <div className={classes.content}>
            <p>{`URL (${url}) is not a valid YouTube link`}</p>
          </div>
        );
      }
    case "vimeo":
      try {
        // const vurl = `https://player.vimeo.com/video/${
        //   url.split("vimeo.com/")[1].split("&")[0]
        // }?title=0&byline=0&portrait=0`;
        const vurl = `https://tools.theatro360.com/vimeo/${
          url.split("vimeo.com/")[1].split("&")[0]
        }${
          session
            ? `/${session}?no_bg=1&force=${hasControl ? 1 : 0}`
            : "?no_cowatch=1&no_bg=1"
        }`;
        return (
          <div className={classes.aspectRatio}>
            <iframe
              scrolling="no"
              title="Vimeo Embed"
              src={encodeURI(vurl)}
              width="100%"
              height="100%"
              allowFullScreen
              frameBorder="0"
              allow="autoplay; encrypted-media"
            />
          </div>
        );
      } catch (err) {
        console.error("Vimeo link error", err);
        return (
          <div className={classes.content}>
            <p>{`URL (${url}) is not a valid Vimeo link`}</p>
          </div>
        );
      }
    default:
      return (
        <video controls autoPlay className={classes.video}>
          <source src={url} type={mimeType} />
        </video>
      );
  }
};

export default Video;
